import Http from '@/services/httpAi'

export const getPlatformSettings = () => Http.get('/admin/platform-settings')
export const updatePlatformSetting = (key, value) => Http.patch(`/admin/platform-settings/${key}`, { value })
